import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { RichTextEditor } from '~components'
import { Input } from '~stories'

import styles from './UniversalTemplateFields.module.css'

const { Text } = Typography

const UniversalTemplateTextFields = ({ text, onChange }) => {
  const { headline = '', description = '', disclaimer = '' } = text || {}

  const patch = updates => onChange({ ...text, ...updates })

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Headline</Text>
        <Input
          onChange={e => patch({ headline: e.target.value })}
          placeholder="Enter headline text"
          value={headline}
        />
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Description</Text>
        <div style={{ marginTop: 4 }}>
          <RichTextEditor
            minHeight={160}
            onChange={html => patch({ description: html })}
            placeholder="Write description content…"
            stripColors
            value={description}
          />
        </div>
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Disclaimer</Text>
        <div style={{ marginTop: 4 }}>
          <RichTextEditor
            defaultFontSize="10px"
            minHeight={120}
            onChange={html => patch({ disclaimer: html })}
            placeholder="Write disclaimer content…"
            stripColors
            value={disclaimer}
          />
        </div>
      </div>
    </div>
  )
}

UniversalTemplateTextFields.propTypes = {
  onChange: PropTypes.func.isRequired,
  text: PropTypes.object
}

export default UniversalTemplateTextFields
